

import { useState, useEffect } from 'react';

function useAdmin() {
  const [isAdmin, setIsAdmin] = useState(false);

  console.log(isAdmin)

  useEffect(() => {
    const adminStatus = localStorage.getItem('admin');
    setIsAdmin(adminStatus === 'true');
  }, []); // Le tableau vide signifie que cet effet ne s'exécutera qu'une seule fois

  return isAdmin;
}

export default useAdmin;